import { IBusinessSubList } from 'src/models/management/business/BusinessSubList';
import { separateFilesAndPaths } from 'src/utils/separateFilesAndPaths';

// 파일과 경로 분리를 처리하는 유틸 함수
export const processImagePaths = (
  currentPaths: Array<string | File>,
  originalPaths: string[] = [],
) => {
  const { files: uploadFiles, paths: existingPaths } = separateFilesAndPaths(currentPaths);
  const deletePaths = originalPaths.filter((path) => !existingPaths.includes(path));

  return { uploadFiles, existingPaths, deletePaths };
};

// 서브 컨텐츠 추가했을 때 이미지 처리 함수
export const processBusinessSubList = (
  businessSubList: IBusinessSubList[] = [],
  originalBusinessSubList: IBusinessSubList[] = [],
) =>
  businessSubList.map((info, index) => {
    const originalInfo = originalBusinessSubList[index] || {};
    const desktop = processImagePaths(info.desktopImgPath || [], originalInfo.desktopImgPath || []);
    const mobile = processImagePaths(info.mobileImgPath || [], originalInfo.mobileImgPath || []);

    return {
      ...info,
      ...(desktop.uploadFiles.length > 0 && { desktopImageFiles: desktop.uploadFiles }),
      ...(desktop.existingPaths.length > 0 && { desktopImgPath: desktop.existingPaths }),
      ...(desktop.deletePaths.length > 0 && { deleteDesktopImageFiles: desktop.deletePaths }),
      ...(mobile.uploadFiles.length > 0 && { mobileImageFiles: mobile.uploadFiles }),
      ...(mobile.existingPaths.length > 0 && { mobileImgPath: mobile.existingPaths }),
      ...(mobile.deletePaths.length > 0 && { deleteMobileImageFiles: mobile.deletePaths }),
    };
  });
